import React, { useRef, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Logo from "../../assets/images/logo.svg";
import Menu from "../../assets/icons/menudots.svg";
import InactiveBullet from "../../assets/icons/inactivebullet.svg";
import ActiveBullet from "../../assets/icons/activebullet.svg";
import MenuBox from "../Menu";

const Dashboard = () => {
  const scrollRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);

  const [menu, setMenuActive] = useState(false);
  const totalPages = 3; // Total pages set to 3

  // Auto-scroll every 1 second
  useEffect(() => {
    const interval = setInterval(() => {
      let nextPage = currentPage + 1;

      // Check if we're at the last page (Page 3)
      if (nextPage === totalPages) {
        nextPage = 0; // Jump to Page 1 directly
      }

      // Calculate the scroll position for the next page
      const scrollTo = nextPage * window.innerWidth;

      // Scroll to the next page with smooth transition
      scrollRef.current?.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      });

      setCurrentPage(nextPage); // Update the current page
    }, 3000);

    return () => clearInterval(interval); // Cleanup the interval on unmount
  }, [currentPage]);

  // Update current page on manual scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollLeft = scrollRef.current.scrollLeft;
      const pageWidth = window.innerWidth;
      const newPage = Math.round(scrollLeft / pageWidth);
      setCurrentPage(newPage);
    };

    const scrollEl = scrollRef.current;
    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box sx={{ height: "100vh", width: "100vw" }}>
      {/* Page indicators */}
      <Box
        sx={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 10,
          display: "flex",
          gap: 1.5,
        }}
      >
        {[...Array(totalPages)].map((_, i) => (
          <Box
            key={i}
            sx={{
              width: 12,
              height: 12,
              paddingRight: "10px",
              transition: "all 0.3s ease-in-out",
            }}
          >
            <img
              style={{
                height: currentPage === i ? "16px" : "12px",
              }}
              src={currentPage === i ? ActiveBullet : InactiveBullet}
              alt="Bullet"
            />
          </Box>
        ))}
      </Box>

      {/* Scrollable Pages */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          height: "100%",
          width: "100%",
          "&::-webkit-scrollbar": { display: "none" },
          scrollBehavior: "smooth", // Smooth scroll behavior for auto scroll
        }}
      >
        {/* , <Page1 />, <Page2 /> */}
        {[<Page1 />, <Page2 />, <Page3 />].map((Page, index) => (
          <Box
            key={index}
            sx={{
              flex: "0 0 100vw",
              height: "100%",
              scrollSnapAlign: "start",
              overflowY: "auto",
              boxSizing: "border-box",
            }}
          >
            {Page}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Dashboard;
